// extracted by mini-css-extract-plugin
export var marginNegative = "_7g-5 _7g-3 _7g-1";
export var marginPositive = "_7g-4 _7g-3 _7g-1";
export var modalContent = "_7g-6";
export var samplesTable = "_7g-8";
export var samplesTableContainer = "_7g-7";
export var statBox = "_7g-a";
export var tableCell = "_7g-1";
export var tableCellCenter = "_7g-2 _7g-1";
export var tableCellRight = "_7g-3 _7g-1";
export var tableHeader = "_7g-0";
export var trackingNumber = "_7g-9";